export default __webpack_public_path__ + "static/media/spiral_stairs_tate_modern.1349c5d8.jpg";